<div class="fixed z-50">
  <!-- Overlay -->
  <div
    class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-75 backdrop-blur-sm"
  ></div>
  <!-- Panel -->
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
        <div
          class="w-screen max-w-4xl px-4 py-4 bg-white dark:bg-zinc-950 h-screen overflow-y-auto rounded-l-lg"
        >
          <!-- Header -->
          <div class="flex justify-end">
            <button
              type="button"
              (click)="onClose()"
              class="p-1 rounded-lg hover:bg-zinc-950/5 dark:hover:bg-white/5"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <!-- Form -->
            <div class="flex justify-between align-middle">
            <div
              [ngClass]="
                fareDetails && (fareDetails | keyvalue).length > 0
                  ? 'w-3/5'
                  : 'w-full'
              "
            >
              <form [formGroup]="form">
                <!-- Funding Source & Transport Provider -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                  <div>
                    <label
                      class="block text-sm font-medium text-main-secondary"
                    >
                      Funding Source <span class="text-red-600">*</span>
                    </label>
                    <ng-select
                      name="fundingsource"
                      formControlName="fundingsource"
                      [clearable]="false"
                      (change)="onSelectChange($event, 'fundingsource')"
                    >
                      <ng-option value="">Select Funding Source</ng-option>
                      <ng-option
                        *ngFor="let fs of fundingSourceList"
                        [value]="fs.id"
                      >
                        {{ fs.title }}
                      </ng-option>
                    </ng-select>
                 <div *ngIf="submitted && form.errors?.eitherRequired" class="text-red-600 text-xs mt-1">
                    Either Company or Funding Source is required
                  </div>
                  </div>

                  <div>
                    <label
                      class="block text-sm font-medium text-main-secondary"
                    >
                      Company <span class="text-red-600">*</span>
                    </label>
                    <ng-select 
                     name="company"
                    formControlName="company"
                    [clearable]="false"
                    (change)="onSelectChange($event, 'company')">
                      <ng-option value="">Select Company</ng-option>
                      <ng-option
                        *ngFor="let company of CompanyList"
                        [value]="company.id"
                      >
                        {{ company.name }}
                      </ng-option>
                    </ng-select>
                  <div *ngIf="submitted && form.errors?.eitherRequired" class="text-red-600 text-xs mt-1">
                     Either Company or Funding Source is required
                     </div>
                  </div>
                </div>

                <!-- Level of Service & Space Type -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                

                  <div
                    *ngIf="form.get('levelOfService')?.value"
                    class="sm:col-span-1"
                  >
                    <label
                      for="spaceType"
                      class="block text-sm font-medium text-main-secondary"
                    >
                      Space Type <span class="text-red-600">*</span>
                    </label>
                    <div class="mt-1">
                      <ng-select
                        id="spaceType"
                        formControlName="spaceType"
                        [clearable]="false"
                      >
                        <ng-option value="">Select Space Type</ng-option>
                        <ng-option
                          *ngFor="let spaceType of spaceTypeList"
                          [value]="spaceType.id"
                          (change)="onSelectSpaceType($event)"
                        >
                          {{ spaceType.title | titlecase }}
                        </ng-option>
                      </ng-select>
                    </div>
                    <div
                     *ngIf="submitted && form.get('spaceType')?.errors"
                      class="text-red-600 text-xs mt-1"
                    >
                      Space Type is required
                    </div>
                  </div>
                </div>

                <!-- Pickup Section -->
                <div class="mt-6" formGroupName="pickup">
                  <h3 class="text-lg font-medium text-xs-dark">PickUp</h3>
                  <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                    <div
                      class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2"
                    >
                      <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
                        <div class="sm:col-span-1">
                          <label
                            for="pickupTimeCal"
                            class="block text-sm font-medium text-main-secondary"
                            >Time</label
                          >
                          <div class="mt-1 relative">
                            <input
                              type="text"
                              name="pickupTimeCal"
                              id="pickupTimeCal"
                              formControlName="time"
                              readonly
                              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed"
                            />
                            <div
                              class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
                            >
                              <span class="text-gray-500 sm:text-sm">
                                <!-- svg icon -->
                              </span>
                            </div>
                          </div>
                        </div>

                        <div formGroupName="address" class="sm:col-span-1">
                          <label
                            for="pickupAddressCal"
                            class="block text-sm font-medium text-main-secondary"
                            >Address</label
                          >
                          <div class="mt-1 flex gap-px">
                            <input
                              type="text"
                              id="pickupAddressCal"
                              name="pickupAddressCal"
                              formControlName="name"
                              readonly
                              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed"
                              placeholder="Pickup address"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Dropoff Section -->
                <div class="mt-6" formGroupName="destination">
                  <h3 class="text-lg font-medium text-xs-dark">Dropoff</h3>
                  <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                    <div
                      class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2"
                    >
                      <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
                        <div class="sm:col-span-1">
                          <label
                            for="dropoffTimeCal"
                            class="block text-sm font-medium text-main-secondary"
                            >Time</label
                          >
                          <div class="mt-1 relative">
                            <input
                              type="text"
                              name="dropoffTimeCal"
                              id="dropoffTimeCal"
                              formControlName="time"
                              readonly
                              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed"
                            />
                          </div>
                        </div>

                        <div formGroupName="address" class="sm:col-span-1">
                          <label
                            for="dropoffAddressCal"
                            class="block text-sm font-medium text-main-secondary"
                            >Address</label
                          >
                          <div class="mt-1 flex gap-px">
                            <input
                              type="text"
                              id="dropoffAddressCal"
                              name="dropoffAddressCal"
                              formControlName="name"
                              readonly
                              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed"
                              placeholder="Dropoff address"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- <div
              *ngIf=" && (fareDetails | keyvalue).length > 0"
              class="w-auto mt-3 overflow-y-auto space-y-2 p-2 order-1 h-full flex-shrink-0 sm:w-auto md:w-3/5 lg:w-80"
            >
              <div class="space-y-2">
                <div class="flex items-center gap-1 text-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="size-4"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M12.442 21.5L8.981 5.489L6.396 17.5H2.5v-1h3.085l2.806-13h1.186l3.473 16.07L15.366 9.5h1.25l1.8 7H21.5v1h-3.866l-1.623-6.354L13.635 21.5z"
                    />
                  </svg>
                  <h2 class="subheading text-primary">Fare Breakdown</h2>
                </div>

                <ul
                  class="text-sm-light space-y-1 rounded-lg border p-2 border-zinc-950/10 dark:border-white/10"
                >
                  <li
                    *ngFor="let item of fareDetails | keyvalue"
                    class="flex items-start justify-between"
                  >
                    <div class="flex items-center space-x-1">
                      <div class="text-sm-light">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="size-4"
                        >
                          <path
                            fill="currentColor"
                            d="M8 20v-4H4v-2h4v-4H4V8h4V4h2v4h4V4h2v4h4v2h-4v4h4v2h-4v4h-2v-4h-4v4zm2-6h4v-4h-4z"
                          ></path>
                        </svg>
                      </div>
                      <div class="text-sm-light">{{ item.key }}</div>
                    </div>

                    <p class="text-sm-dark">
                      <ng-container
                        *ngIf="
                          item.value !== null && item.value !== undefined;
                          else dash
                        "
                      >
                        <ng-container
                          *ngIf="isNumberValue(item.value); else notNumber"
                        >
                          {{ item.value }}
                        </ng-container>
                        <ng-template #notNumber>
                          {{ item.value }}
                        </ng-template>
                      </ng-container>
                      <ng-template #dash>-</ng-template>
                    </p>
                  </li>
                </ul>
              </div>
            </div> -->
          
           <div *ngIf="fareDetails  && (fareDetails | keyvalue).length > 0"
              class="w-auto mt-3 overflow-y-auto space-y-2 p-2 order-1 h-full flex-shrink-0 sm:w-auto md:w-3/5 lg:w-80">
                              <div class="flex items-center gap-1 text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 24 24">
                                  <path fill="currentColor"
                                    d="M12.442 21.5L8.981 5.489L6.396 17.5H2.5v-1h3.085l2.806-13h1.186l3.473 16.07L15.366 9.5h1.25l1.8 7H21.5v1h-3.866l-1.623-6.354L13.635 21.5z" />
                                </svg>
                                <h2 class="subheading text-primary">Rate Breakdown</h2>
                              </div>
                              <ul 
                                class="text-sm-light space-y-1 rounded-lg border p-2 border-zinc-950/10 dark:border-white/10">
                              <li *ngFor="let item of getSortedBreakdown(fareDetails)" class="flex items-start justify-between">
                                <div class="flex items-center space-x-1">
                                  <div class="text-sm-light">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="size-4">
                                      <path fill="currentColor" d="M8 20v-4H4v-2h4v-4H4V8h4V4h2v4h4V4h2v4h4v2h-4v4h4v2h-4v4h-2v-4h-4v4zm2-6h4v-4h-4z">
                                      </path>
                                    </svg>
                                  </div>
                                  <div class="text-sm-light">{{ item.key }}</div>
                                </div>
                                <p class="text-sm-dark">{{ formatValue(item.value) }}</p>
                              </li>
                              </ul>
                            </div>
          </div>

          <div
            class="fixed bottom-0 right-0 w-full max-w-4xl px-4 py-3 bg-white dark:bg-zinc-950 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3"
          >
            <button
              type="submit"
              class="btn btn-secondary"
              (click)="onSubmit()"
            >
              Calculate
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
